/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profilelinkdone2Inputs */

const en_profilelinkdone2 = /** @type {(inputs: Profilelinkdone2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is now connected`)
};

const de_profilelinkdone2 = /** @type {(inputs: Profilelinkdone2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist jetzt verbunden`)
};

/**
* | output |
* | --- |
* | "{name} is now connected" |
*
* @param {Profilelinkdone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkdone2 = /** @type {((inputs: Profilelinkdone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkdone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkdone2(inputs)
	return de_profilelinkdone2(inputs)
});
export { profilelinkdone2 as "profileLinkDone" }